module.exports = {
  global: {
    ruleLabel: '规则说明',
    shareSuccess: "分享成功",
    shareFail: "分享失败",
    moreButtonLabel: '查看更多',
    goShopping: '去抢购',
    gameOver: '亲爱的朋友，活动结束了！',
    moreGame: '发现更多精彩 >',
    acquired: '已领取',
    outOfScope: '您当前的位置不在活动范围',
    switchPositioning: '切换定位获取信息',
    cashCoupons:'现金券',
    discountCoupon:'折扣券',
    minDiscountCoupon:'满减券',
    openApp: '打开APP',
    shareText: '我在大象APP发现一个超级赞的内容，推荐给你看看',
    sort: '排序',
    store_rest: '休息中，营业时间: {value}',
    resting: '休息中',
    delivery_busy_available: '繁忙·30分钟后可下单',
    delivery_busy: '繁忙',
    stoped: '已停业',
    not_in_scope: '不在配送范围',
    delivery_shipping_fee_reduce: "减配送费",
  },
  enums: {
    sortType: {
      wm_sort_Find_more: '全部筛选',
      wm_sort_Good_rates: '好评优先',
      wm_sort_Best_sell: '销量最高',
      wm_sort_Nearest: '距离最近'
    },
    flag_new: '新店',
    hide: '收起',
    expand: '展开',
  },
  cmsCoupon: {
    deliveryCoupons: '配送券',
    notThreshold: "无门槛",
    hasThreshold: "满{money}可用",
    notStart: '未开始',
    amountHasOut: '已抢光',
    endAct: "活动已结束",
    goToUse: "去使用",
    successToast: '领取成功',
    clickToRedeem: "一键领取"
  },
  cmsSuperCoupon: {
    csuper_pageTitle: "大象神券",
    csuper_coupon: "大象神券",
    discount: "限时折扣{value}折",
    purchase_history: '购买记录',
    delivery_up_to_off: '最高减{money}',
    can_expand_up_to: '膨胀最高减{money}',
    purchasing: '购买',
    delivery_piece: '张',
    group_on_score_empty: "暂无评分",
  }
}
